import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { ICellRendererAngularComp } from 'ag-grid-angular';

import { ReportsService, TransformedSingleData } from '../../services/reports.service';
import { CommonService } from '../../services/common.service';
import { ICellRendererParams } from 'ag-grid-community';

@Component({
  selector: 'vrm-grid-see-mvr-button',
  template: `
    <span *ngIf="originalValue !== 'na'">
      <button
        mat-button
        fxFlex
        class="grid-link-button grid-text"
        [style.color]="transformedValue?.color"
        (click)="triggerLinkButtonAction()"
      >
        {{ value }}
      </button>
    </span>
    <span *ngIf="originalValue === 'na'">{{ value }}</span>
  `,
  styles: [],
})
export class GridSeeMvrLinkButtonComponent implements ICellRendererAngularComp {
  public value: string;
  public transformedValue: TransformedSingleData;
  public originalValue: string;

  constructor(private router: Router, private cService: CommonService, public rptService: ReportsService) {}

  agInit(params: ICellRendererParams) {
    this.originalValue = params.data.indexingLicenceStatus;
    this.transformedValue = this.rptService.transformSingleDataForDetailsPane('indexingLicenceStatus', params.value);

    this.value = this.transformedValue
      ? this.cService.toVrmCaps(this.transformedValue.uiValue)
      : this.cService.toVrmCaps(params.value);
  }

  triggerLinkButtonAction() {
    if (this.cService.mvrPageHidden()) {
      this.cService.showToastWithoutDuration(
        this.cService.readyTranslations.messagesAndWarnings.insufficientPermissionToViewRequestedPage,
        'close'
      );
    } else {
      setTimeout(() => {
        this.rptService.gridSearch.text = this.rptService.selectedRows[0]['pin'];
        this.rptService.gridSearch.activated = true;

        this.router.navigate(['commonreports/mvr-main']);
      }, 250);
    }
  }

  refresh() {
    return false;
  }
}
